/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useEffect, useRef } from 'react';

import type React from 'react';

export const useAutoFocus = (): React.RefObject<HTMLInputElement | null> => {
    const inputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        setTimeout(() => inputRef.current?.focus(), 50);
    }, []);

    return inputRef;
};
